import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';

export const tailoredSupplyCreateFormSchema = z.object({
  name: z.string().trim().min(1, dashboardT('tailoredSupply.nameRequired')).max(255),
  description: z.string().trim(),
});

export type TailoredSupplyCreateFormValue = z.infer<typeof tailoredSupplyCreateFormSchema>;
